/* */ 
'use strict';
var ono = require('ono'),
    $Ref = require('./ref'),
    url = require('./util/url');
module.exports = $Refs;
function $Refs() {
  this.circular = false;
  this._$refs = {};
  this._root$Ref = null;
}
$Refs.prototype.paths = function(types) {
  var paths = getPaths(this._$refs, arguments);
  return paths.map(function(path) {
    return path.decoded;
  });
};
$Refs.prototype.values = function(types) {
  var $refs = this._$refs;
  var paths = getPaths($refs, arguments);
  return paths.reduce(function(obj, path) {
    obj[path.decoded] = $refs[path.encoded].value;
    return obj;
  }, {});
};
$Refs.prototype.toJSON = $Refs.prototype.values;
$Refs.prototype.exists = function(path, options) {
  try {
    this._resolve(path, options);
    return true;
  } catch (e) {
    return false;
  }
};
$Refs.prototype.get = function(path, options) {
  return this._resolve(path, options).value;
};
$Refs.prototype.set = function(path, value) {
  path = url.resolve(this._root$Ref.path, path);
  var withoutHash = url.stripHash(path);
  var $ref = this._$refs[withoutHash];
  if (!$ref) {
    throw ono('Error resolving $ref pointer "%s". \n"%s" not found.', path, withoutHash);
  }
  $ref.set(path, value);
};
$Refs.prototype._add = function(path, value) {
  var withoutHash = url.stripHash(path);
  var $ref = new $Ref();
  $ref.path = withoutHash;
  $ref.value = value;
  $ref.$refs = this;
  this._$refs[withoutHash] = $ref;
  this._root$Ref = this._root$Ref || $ref;
  return $ref;
};
$Refs.prototype._resolve = function(path, options) {
  path = url.resolve(this._root$Ref.path, path);
  var withoutHash = url.stripHash(path);
  var $ref = this._$refs[withoutHash];
  if (!$ref) {
    throw ono('Error resolving $ref pointer "%s". \n"%s" not found.', path, withoutHash);
  }
  return $ref.resolve(path, options);
};
$Refs.prototype._get$Ref = function(path) {
  path = url.resolve(this._root$Ref.path, path);
  var withoutHash = url.stripHash(path);
  return this._$refs[withoutHash];
};
function getPaths($refs, types) {
  var paths = Object.keys($refs);
  types = Array.isArray(types[0]) ? types[0] : Array.prototype.slice.call(types);
  if (types.length > 0 && types[0]) {
    paths = paths.filter(function(key) {
      return types.indexOf($refs[key].pathType) !== -1;
    });
  }
  return paths.map(function(path) {
    return {
      encoded: path,
      decoded: $refs[path].pathType === 'file' ? url.toFileSystemPath(path, true) : path
    };
  });
}
